import { useMemo } from 'react';

import moment from 'moment';
import { DatePickerPreset } from 'twyne-new.ui'

import appStore from 'stores/app.js';

export default function DateTimeRange({ value, onChange, ...props }) {
  const normalizeDate = date => moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), appStore.timezone)

  const range = useMemo(() => value || {
    $gte: moment.tz(appStore.timezone).startOf('day'),
    $lte: moment.tz(appStore.timezone).endOf('day'),
  }, [value])

  const handleChange = dates => {
    onChange({
      $gte: normalizeDate(dates.$gte),
      $lte: normalizeDate(dates.$lte),
    })
  }

  return <DatePickerPreset
    value={range}
    numberOfMonths={2}
    mask="MM/DD/YYYY"
    onChange={handleChange}
    {...props}
  />
}
